import type { GovernanceCheckPreviewResponse } from '$/requests/GovernanceCheck.ts';
import type { GovernedRecommendationContent } from '@/pages/recommendationEngine/governedRecommendationTypes.ts';

export function mapGovernanceCheckPreviewToContent(
  res: GovernanceCheckPreviewResponse,
): GovernedRecommendationContent {
  return {
    issue_title: res.issue_title,
    constraint_summary: res.constraint_summary,
    framework_id: res.framework_id,
    confidence_score: res.confidence_score,
    recommended_direction: res.recommended_direction,
    root_cause: res.root_cause_diagnosis,
    action_plan: res.action_plan,
    expected_impact: res.expected_impact,
    risks_watchouts: res.risks_watchouts,
    next_30_days: res.next_30_days,
  };
}
